
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import simplify from "@turf/simplify";
import LayerCable from "../classes/LayerCable";

const DrawLineString = MapboxDraw.modes.draw_line_string;
const geojsonTypes = MapboxDraw.constants.geojsonTypes;
const cursors = MapboxDraw.constants.cursors;
const types = MapboxDraw.constants.types;
const updateActions = MapboxDraw.constants.updateActions;
const modes = MapboxDraw.constants.modes;
const events = MapboxDraw.constants.events;

let tempState;

const cableMode = Object.assign({}, DrawLineString)

cableMode.user_color = "#5078FF";

cableMode.onSetup = function(opts) {
	opts = opts || {};

	let line, currentVertexPosition = (opts.startCoordinate ? 1 : 0);
	this.onFinish = opts.onFinish;
	if(opts.powerlines)
		this.powerlines = opts.powerlines;
	if(opts.toolCable)
		this.toolCable = opts.toolCable;


	let direction = 'forward';

	line = this.newFeature({
		type: geojsonTypes.FEATURE,
		properties: {
			color:cableMode.user_color,
			width:cableMode.user_width
		},
		geometry: {
			type: geojsonTypes.LINE_STRING,
			coordinates: opts.startCoordinate ? [opts.startCoordinate] : []
		},
		id:'added_cable'
	});


	this.addFeature(line);

	this.clearSelectedFeatures();

	this.updateUIClasses({ mouse: cursors.ADD });
	this.setActionableState({
		trash: true
	});

	var state = {
		line,
		currentVertexPosition: currentVertexPosition,
		dragMoving: false,
		direction
	}
	if(opts.handles && opts.handles.length)
		this.onHandleClick(opts.handles, state);

	return state;
};

cableMode.onRightDrag = function(e){
	tempState.dragMoving = true;
	tempState.line.updateCoordinate(tempState.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	tempState.currentVertexPosition++;
	tempState.line.updateCoordinate(tempState.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
}

cableMode.onMouseDown = function(state, e) {

	tempState = state;

	if(e.originalEvent.which == 3){
		this.map.on("mousemove", cableMode.onRightDrag);
	}

};

cableMode.onMouseUp = function(state, e){
	if (e.originalEvent.which == 3 && state.dragMoving) {
		tempState.dragMoving = false;
		this.map.off("mousemove", cableMode.onRightDrag);
	}
}
cableMode.onHandleClick = function(handles, state) {

	if(handles.length){
		const cableId = handles[0].properties.powerlineid;
		const direction = handles[0].properties.position;

		var idx = this.powerlines.findIndex((p)=>{
			return p.powerlineid == cableId || (p.properties && p.properties.tempid == cableId);
		});

		if(idx>-1){
			const geo = structuredClone(this.powerlines[idx].geometry);

			geo.coordinates = geo.type == "MultiLineString" ? geo.coordinates[0] : geo.coordinates;

			if(direction == 1){

				if(state.line.coordinates.length<2){
					geo.coordinates.reverse();
					state.line.setCoordinates([...geo.coordinates, ...state.line.coordinates]);
				}
				else{
					state.line.coordinates.pop();
					state.line.setCoordinates([...state.line.coordinates, ...geo.coordinates]);
				}
			}
			else {
				if(state.line.coordinates.length<2){
					state.line.setCoordinates([...geo.coordinates]);
				}
				else{
					geo.coordinates.reverse();
					state.line.coordinates.pop();
					state.line.setCoordinates([...state.line.coordinates, ...geo.coordinates]);
				}
			}

			delete this.powerlines[idx].geometry;

			state.currentVertexPosition = state.line.coordinates.length;

			return;
		}

	}
}
cableMode.onIntersect = function(intersects, state, e){

	if(intersects.length){
		const coords = [e.lngLat.lng, e.lngLat.lat];

		const cableId = intersects[0].properties.powerlineid;
		var idx = this.powerlines.findIndex((p)=>{
			return p.powerlineid == cableId || (p.properties && p.properties.tempid == cableId);
		});

		if(idx>-1){
			const points = this.powerlines[idx].geometry.type == "MultiLineString" ? this.powerlines[idx].geometry.coordinates[0] : this.powerlines[idx].geometry.coordinates;

			const i = this.findIntersect(points, coords);

			if(i !== false){
				points.splice(i, 0, coords);
			}

			state.line.addCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
			this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
		}
	}
}

cableMode.findIntersect = function(line, coords){

	var i = line.findIndex((c, idx)=>{

		if(line[idx+1]){
			return (
					(coords[0] >= c[0]  && coords[0] <= line[idx+1][0])
					||
					(coords[0] <= c[0]  && coords[0] >= line[idx+1][0])
				) && (
					(coords[1] >= c[1]  && coords[1] <= line[idx+1][1])
					||
					( coords[1] <= c[1]  && coords[1] >= line[idx+1][1])
				);

		}
		return false;
	});

	if(i > -1)
		return i+1;

	return false;

}
cableMode.clickOnVertex = function(state) {
  return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
};
cableMode.clickAnywhere = function(state, e) {
	/*
	var handles = this.map.queryRenderedFeatures(e.point, {layers:[LayerCable.handlesId]});

	var intersects = this.map.queryRenderedFeatures(e.point, {layers:[LayerCable.bufferId]});


	if(handles && handles.length){
		this.onHandleClick(handles, state);
		return;
	}
	if(intersects && intersects.length){
		this.onIntersect(intersects, state, e);
		return;
	}
	*/

	if (state.currentVertexPosition > 0 && MapboxDraw.lib.isEventAtCoordinates(e, state.line.coordinates[state.currentVertexPosition - 1]) ||
		state.direction === 'backwards' && MapboxDraw.lib.isEventAtCoordinates(e, state.line.coordinates[state.currentVertexPosition + 1])) {
		return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
	}
	this.updateUIClasses({ mouse: cursors.ADD });
	state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	if (state.direction === 'forward') {
		state.currentVertexPosition++;
		state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	}
	else {
		state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat);
	}
};
cableMode.onTouchEnd = function(state, e) {
	this.onMouseUp(state, e)
}

cableMode.fireUpdate = function() {
	this.map.fire(events.UPDATE, {
		action: updateActions.MOVE,
		features: this.getSelected().map(f => f.toGeoJSON())
	});
};

cableMode.simplify = function(polygon) {
	const tolerance = 1 / Math.pow(1.05, 100 * this.map.getZoom());
	simplify(polygon, {
		mutate: true,
		tolerance: tolerance,
		highQuality: true
	});
};

cableMode.toDisplayFeatures = function(state, geojson, display) {
	const isActiveLine = geojson.properties.id === state.line.id;
	geojson.properties.active = (isActiveLine) ? MapboxDraw.constants.activeStates.ACTIVE : MapboxDraw.constants.activeStates.INACTIVE;
	if (!isActiveLine) return display(geojson);
	if (geojson.geometry.coordinates.length < 2) return;
	geojson.properties.meta = MapboxDraw.constants.meta.FEATURE;

	var vertex = MapboxDraw.lib.createVertex(
		state.line.id,
		geojson.geometry.coordinates[state.direction === 'forward' ? geojson.geometry.coordinates.length - 2 : 1],
		`${state.direction === 'forward' ? geojson.geometry.coordinates.length - 2 : 1}`,
		false
	);

	vertex.properties.user_color = cableMode.user_color;

	display(vertex);

	display(geojson);
};

export default cableMode
